import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      minHeight: 600,
      padding: theme.spacing(2),
      width: '100%',
    },
    headZero: {
      maxWidth: 75,
      minWidth: 75,
    },
    head: {
      maxWidth: 75,
      minWidth: 75,
    },
    theadBg: {
      background: `'#14171A' !important`,
      '& td': {
        color: `${theme.palette.colors.white} !important`,
      },
    },
    tableContainer: {
      borderRadius: 0,
    },
    table: {
      '& th:first-child': {
        borderTopLeftRadius: 15,
      },
      '& th:last-child': {
        borderTopRightRadius: 15,
      },
      '& tr:last-child ': {
        '& td:first-child': { borderBottomLeftRadius: 15 },
        '& td:last-child': { borderBottomRightRadius: 15 },
      },

      '& table': {
        borderRadius: 15,
        marginBottom: 30,
      },
      '& thead': {
        background: '#14171A ',
        borderRadius: '15px 15px 0px 0px',
      },
      '& thead th': {
        color: '#fff',
        borderBottom: 'none',
      },
      '& thead tr > *': {
        padding: theme.spacing(1, 2),
      },
      '& tbody tr > *': {
        padding: theme.spacing(0.5, 2),
      },

      '& td': {
        borderBottom: 'none',
      },
      '& tbody tr:nth-of-type(odd) ': {
        background: '#fff',
      },
    },
    header: {
      cursor: 'pointer',
    },
    tr: {
      background: `'#14171A' `,
    },
    evenRow: {
      background: '#fff ',
    },
    oddRow: {
      background: '#F5F8FA ',
    },
  }),
);

export default useStyles;
